import { useState } from 'react'
import type { JSX } from 'react'

import {
  DropdownMenu,
  EllipsisIcon,
  IconButton,
  PencilIcon,
  TrashIcon,
} from '@buffer-mono/popcorn'

type SavedViewItemMenuProps = {
  className?: string
  viewName: string
  viewId: string
  onRename: () => void
  onDelete: () => void
}

/**
 * Context menu for a saved view. Pure controlled menu: the parent owns the
 * Rename/Delete dialog state and mounts the dialogs as siblings of both this
 * menu and the NavLink, so interactions here never descend into the link.
 */
export function SavedViewItemMenu({
  className,
  viewName,
  viewId,
  onRename,
  onDelete,
}: SavedViewItemMenuProps): JSX.Element {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <DropdownMenu open={menuOpen} onOpenChange={setMenuOpen}>
      <DropdownMenu.Trigger asChild>
        <IconButton
          variant="tertiary"
          size="small"
          label={`View options for ${viewName} (${viewId})`}
          tooltip="View options"
          className={className}
          data-open={menuOpen || undefined}
        >
          <EllipsisIcon />
        </IconButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="end">
        <DropdownMenu.Item onSelect={onRename}>
          <PencilIcon />
          Rename
        </DropdownMenu.Item>
        <DropdownMenu.Item variant="critical" onSelect={onDelete}>
          <TrashIcon />
          Delete
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  )
}
